/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React, { Fragment } from 'react'
import './CInsuranceSubHeader.scss'
import { IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface ICInsuranceSubHeaderProps {
	data: IInpatientTypeInsurance
}
export class CInsuranceSubHeader extends React.Component<ICInsuranceSubHeaderProps> {
	render(): React.ReactNode {
		const model = this.props.data
		if (typeof model !== 'undefined' && model !== null) {
			return (
				<Fragment>
					{this.renderInsuranceTypeDescription(model)}
					{this.renderCoverageLevelDescription(model)}
				</Fragment>
			)
		}
		return null
	}

	renderInsuranceTypeDescription(model: IInpatientTypeInsurance): any {
		return typeof model.insuranceTypeDescription !== 'undefined' && model.insuranceTypeDescription !== null && model.insuranceTypeDescription.trim() !== '' ? (
			<tr className="sub-header">
				<td>Insurance Type:</td>
				<td colSpan={3}>{model.insuranceTypeDescription}</td>
			</tr>
		) : null
	}
	renderCoverageLevelDescription(model: IInpatientTypeInsurance): any {
		return typeof model.coverageLevelDescription !== 'undefined' && model.coverageLevelDescription !== null && model.coverageLevelDescription.trim() !== '' ? (
			<tr className="sub-header">
				<td>Coverage Level:</td>
				<td colSpan={3}>{model.coverageLevelDescription}</td>
			</tr>
		) : null
	}
}
